import axios from 'axios'
import router from '@/router'

export default {
  namespaced: true,

  state: {
    loaded: false,
    loading: false,
    items: []
  },

  mutations: {
    loaded_set (state, val) {
      state.loaded = val
    },

    loading_set (state, val) {
      state.loading = val
    },

    items_set (state, val) {
      state.items = val
    }
  },

  getters: {
    loading: state => !state.loaded,

    // получение элемента по ID, включая удалённые
    getItemByID: state => id => state.items.find(item => item.id === id),

    // не удалённые элементы
    items: state => state.items.filter(i => !i.isDeleted)
  },

  actions: {
    async init ({ commit, state }) {
      // load once
      if (!state.loaded && !state.loading) {
        commit('loading_set', true)
        try {
          const response = await axios.get('/cargoTypes')
          commit('items_set', response.data)
          commit('loaded_set', true)
        } catch {
          router.push('/error?message=Ошибка при загрузке типов груза')
        } finally {
          commit('loading_set', false)
        }
      }
    },

    reset ({ commit }) {
      commit('loaded_set', false)
      commit('items_set', [])
    }
  }
}
